import React from 'react'
import FabricInquiryNewDetails from './FabricInquiryNewDetails'
import VendorFabricInquiryNewDetails from './VendorFabricInquiryNewDetails'

const VendorFabricInquiryNewBody = () => {
  return (
    <div className="view-qualities folded router-view-container">
    <VendorFabricInquiryNewDetails />

</div>
  )
}

export default VendorFabricInquiryNewBody